import styled, { css } from 'styled-components'
import { clientPrimaryColors } from 'common/utils/colors'

// TODO: determine what sizes work for us
const EXTRA_SMALL_SIZE = 25
const SMALL_SIZE = 30
const MEDIUM_SIZE = 50
const LARGE_SIZE = 100
const EXTRA_LARGE_SIZE = 150

interface IMOLoader {
  size?: number | 'xs' | 's' | 'm' | 'l' | 'xl'
}

const MOLoader = styled.div<IMOLoader>`
  ${({ size = 'm' }) => {
    const loaderSize = (() => {
      if (typeof size === 'number') return size

      switch (size) {
        case 'xs':
          return EXTRA_SMALL_SIZE

        case 's':
          return SMALL_SIZE

        case 'm':
          return MEDIUM_SIZE

        case 'l':
          return LARGE_SIZE

        case 'xl':
          return EXTRA_LARGE_SIZE

        default:
          return MEDIUM_SIZE
      }
    })()

    return css`
      width: ${loaderSize}px;
      height: ${loaderSize}px;
      border-radius: ${loaderSize / 2}px;
      border: ${loaderSize / 10}px solid ${clientPrimaryColors().primary_brand_colour};
      border-left-color: transparent;
    `
  }}

  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`

export default MOLoader
